import React from 'react';
import { peopleNeeds, purposeUses } from '../data/content';
import { SunRays } from './decor/SunRays';
export function Purpose() {
  return <section aria-labelledby="purpose-title" className="relative overflow-hidden bg-cream-deep" data-id="element-261" data-mp="2ova1s5lx638k">
      <SunRays className="pointer-events-none absolute -left-48 -bottom-48 w-[520px] text-gold/20" data-id="element-262" data-mp="33jo2a9vv5fly" />
      <div className="relative mx-auto max-w-3xl px-5 py-20 text-center sm:px-8 lg:py-28" data-id="element-263" data-mp="2yqbq4z8df1a3">
        <h2 id="purpose-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-264" data-mp="3chgjxkp24zci">
          This Is More Than a Collection of Printables
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-ink-soft" data-id="element-265" data-mp="3mfwc7qztmenl">
          It’s easy to download another Christian resource and leave it forgotten on your computer. That’s not what this bundle was created for.
        </p>
        <p className="mt-8 font-display text-3xl text-coral sm:text-4xl" data-id="element-266" data-mp="1s3g56nz7awho">It was created to be used.</p>
        <ul className="mt-4 space-y-1" data-id="element-267" data-mp="1n67oysxm52j2">
          {purposeUses.map(u => <li key={u} className="font-display text-2xl text-navy sm:text-[28px]" data-id="element-268" data-mp="agqyi2em4tjc">
              {u}
            </li>)}
        </ul>
        <p className="mt-8 text-lg leading-relaxed text-ink-soft" data-id="element-269" data-mp="jfvxtay00qwk">To help turn ordinary moments into opportunities to point someone toward Christ.</p>

        <div className="mt-12 rounded-[28px] bg-white p-8 text-left shadow-card sm:p-10" data-id="element-270" data-mp="o7dv9p0tc9cs">
          <p className="text-lg font-bold text-navy" data-id="element-271" data-mp="t4vxkwkbrqbt">Because there are people around you right now who may desperately need:</p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-272" data-mp="y2xjdp94y3qz">
            {peopleNeeds.map((n, i) => <li key={n} className={`rounded-xl bg-cream px-5 py-3.5 font-semibold text-navy ${i === peopleNeeds.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-273" data-mp="131qu59x1fgng" data-mpi={i}>
                {n}
              </li>)}
          </ul>
        </div>

        <p className="mt-12 font-display text-4xl italic text-coral sm:text-5xl" data-id="element-274" data-mp="38xbojydaf8is">What if that person is you?</p>
      </div>
    </section>;
}